/* TestEmailComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const Renderer = require("./TestEmailRenderer");

/**
 * @class TestEmailComponent
 * @extends EventEmitter
 *
 * @fires TestEmailComponent#Data
 * @fires TestEmailComponent#Error
 * @fires TestEmailComponent#Shutdown
 */
class TestEmailComponent extends EventEmitter {
    constructor(opts) {
        super();
        this._systemEntity = opts.entity;
        this._connectionEntity = opts.connectionEntity;
        this._config = opts.config;
        this._uiutils = opts.uiutils;
        this._muf = opts.muf;
        this._userEmail = opts.userEmail;
        this._ServiceConnectionEntityDef = opts.serviceConnectionEntityDef;
        this._activeOrgId = opts.activeOrgId;
        this._renderer = new Renderer(this);
    }

    get renderer() {
        return this.getRenderer();
    }

    get rootElement() {
        return this._renderer && this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    _shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        this.removeAllListeners();
        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = null;
                this._shutdownProm = null;
                this._listeners = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    closePopUp() {
        this.rejectPopUp({userRejected: true});
    }

    resolvePopup(data) {
        this._context.resolve(data);
    }

    rejectPopUp(data) {
        this._context.reject(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _triggerShutdown() {
        /**
         * @event TestEmailComponent#Shutdown
         */
        this.emit("Shutdown");
    }

    _setData(data, silent) {
        this._data = data;
        if (!silent) {
            this._triggerData(data);
        }
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    getData() {
        return this._data;
    }

    validate(email) {
        this._muf.displayLoading({
            message: "Sending test email... This could take a moment",
        });
        let message = "Failed to send a test email.";
        const workInput = {
            emailAddress: email,
            serviceConnection: {
                connectionTypeId: this._connectionEntity.connectionTypeId,
                connectionInformation: this._connectionEntity.connectionInformation,
            },
        };
        // Active org, not the connection's owning org: an inherited connection's tenant is an
        // ancestor the caller may not be authorized to launch work against.
        const workTarget = {
            category: "entity",
            entityType: "ServiceConnection",
            method: "single",
            id: this._connectionEntity.id,
        };
        this._ServiceConnectionEntityDef
            .runTestConnectionWork(this._activeOrgId, workTarget, workInput)
            .then((response) => {
                this.resolvePopup();
                if (response) {
                    const errMsg = _.get(response, "summary.errorMsg");
                    if (!errMsg) {
                        message = _.get(
                            response,
                            "summary.response",
                            "Successfully sent a test email."
                        );
                    }
                }
                // const message = !response ? "Failed to send a test email." : (response.result === "error" ? response.error : "Successfully sent a test email.");
                this._uiutils.showMessageDialog({
                    message,
                    confirmButtonName: "OK",
                });
            })
            .catch(() => {
                this.resolvePopup();
                this._uiutils.showMessageDialog({
                    message,
                    confirmButtonName: "OK",
                });
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = TestEmailComponent;
